import React from 'react';
import { arrayOf, node, oneOfType, bool } from 'prop-types';
import { Image } from '@thd-olt-component-react/core-ui';
import { Tile } from '@thd-olt-component-react/tile';
import { useTheme } from '@thd-olt-component-react/theme-provider';
import styles from './empty-messaging-php.module.scss';

export const EmptyMessagingPhp = (props) => {

  const { children } = props;
  const theme = useTheme(EmptyMessagingPhp, props);
  const { showListIcon } = theme.props;

  const emptyMessageObj = showListIcon
    ? {
      assetName: 'list-icon.svg',
      assetAlt: 'List',
      header: 'Plan Out Your Projects',
      p1: 'Create multiple product lists to help you stay',
      p2: 'organized and prepare bids'
    }
    : {
      assetName: 'heart-icon.svg',
      assetAlt: 'Heart',
      header: 'Great Projects Start With a List',
      p1: 'Plan a DIY project, dream up a wish list,',
      p2: 'or create a gift list'
    };

  return (
    <div className={styles['empty-messaging']}>
      <Tile className={styles['empty-messaging__tile']}>
        <div className={styles['empty-messaging__favorite']}>
          <Image asset={emptyMessageObj.assetName} alt={emptyMessageObj.assetAlt} height="40" width="40" />
        </div>
        <h2 className={styles['empty-messaging__get-started']}>
          {emptyMessageObj.header}
        </h2>
        <div className={styles['empty-messaging__plan']}>
          <p>{emptyMessageObj.p1}</p>
          <p>{emptyMessageObj.p2}</p>
        </div>
        {children}
      </Tile>
    </div>
  );
};

EmptyMessagingPhp.displayName = 'UserListsEmptyMessagingPhp';

EmptyMessagingPhp.propTypes = {
  children: oneOfType([node, arrayOf(node)])
};

EmptyMessagingPhp.defaultProps = {
  children: null
};

EmptyMessagingPhp.themeProps = {
  showListIcon: bool
};

EmptyMessagingPhp.defaultThemeProps = {
  showListIcon: false
};
